export default __webpack_public_path__ + "static/media/successcheck.9b0f694b.svg";